export default function ScoreBadge({ score, size = 'md' }: { score: number | null; size?: 'sm' | 'md' | 'lg' }) {
  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-12 h-12 text-sm',
    lg: 'w-16 h-16 text-base',
  };

  if (score == null) {
    return (
      <div className={`${sizeClasses[size]} rounded-full bg-gray-100 text-gray-400 font-bold flex items-center justify-center shrink-0`}>
        –
      </div>
    );
  }

  const bg =
    score >= 80 ? 'bg-green-100 text-green-700' :
    score >= 50 ? 'bg-yellow-100 text-yellow-700' :
    'bg-red-100 text-red-700';

  return (
    <div className={`${sizeClasses[size]} ${bg} rounded-full font-bold flex items-center justify-center shrink-0`}>
      {score}
    </div>
  );
}
